export default __webpack_public_path__ + "static/media/Intel_Core_i5_Logo_2020.11dac659.svg";